export default {"src":"/_next/static/media/arrowup.d16faaff.svg","height":104,"width":224,"blurWidth":0,"blurHeight":0};